import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLList,
  GraphQLID
} from 'graphql'

export interface OrganizationTaggingChangeArg {
  readonly organizationID: string
  readonly ids: string[]
  readonly add: string[]
  readonly remove: string[]
}

export const OrganizationTaggingChangeArgType = new GraphQLInputObjectType({
  name: 'OrganizationTaggingChangeArg',
  description:
    'Parameters that describe a tagging change to one or more more entities of a single type within an organization',
  fields: () => ({
    organizationID: {
      description:
        'The ID of the organization for the entities that will have tags changed.',
      type: new GraphQLNonNull(GraphQLID)
    },
    ids: {
      description: 'IDs of the entities that will have tags changed.',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(GraphQLID)))
    },
    add: {
      description: 'The tags to add',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(GraphQLID)))
    },
    remove: {
      description: 'The tags to remove',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(GraphQLID)))
    }
  })
})
